require('./hireCreditCardError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const {
    KNOWN_ERROR_CODE,
    LOW_CREDIT_SCORE,
    REJECTED,
} = require('constants/hireCardSubmitScenarios');
const { catalogue, analyticsId } = require('../analytics/hireCardNerudaViewAnalytics');

class HireCreditCardError extends React.Component {

    handleGoToDocumentation() {
        this.props.history.push('/myprofile/documentation');
    }

    buildTexts() {
        const {
            getContextTranslate,
            hasAvailableAccounts,
            hireCreditCard,
            maxAllowedNumberCards,
            hireRestrictionFlag,
            getContextKeyTranslate
        } = this.props;
        let titleKey = getContextTranslate('errorTitleGeneric');
        let textElement = (
            <div className="hire-card-neruda-error__text">
                <FormattedText value={getContextTranslate('errorTextGeneric')} />
            </div>
        );

        if (__CONTACT_CENTER__ && !hasAvailableAccounts) {
            titleKey = 'hireCardOpenCredit-errorTitleNotAvailableAccounts';
            textElement = formatText('hireCards-errorTextNotAvailableAccounts');
        } else if (maxAllowedNumberCards) {
            titleKey = 'hireCreditErrors-hireCreditErrors_maxAllowedCardsHiredTitle';
            textElement = formatText('hireCreditErrors-hireCreditErrors_maxAllowedCardsHired');
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />;
        }

        switch (hireCreditCard.get('hiringStatus')) {
            case KNOWN_ERROR_CODE:
                titleKey = getContextTranslate('errorTitleGeneric');
                textElement = (
                    <div>
                        <div className="hire-card-neruda-error__text hire-card-neruda-error__text--margin-bottom">
                            <FormattedText
                                value={`hireCreditErrors-${hireCreditCard.get('errorMsg')}`}
                            />
                        </div>
                        <div className="hire-card-neruda-error__text">
                            <FormattedText
                                value={getContextTranslate('errorTextCallUs2')}
                            />
                        </div>
                        <div className="hire-card-neruda-error__phone">
                            <i className="hire-card-neruda-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value={getContextTranslate('phoneNumberClients')} />
                        </div>
                    </div>
                );
                break;
            case REJECTED:
                titleKey = getContextTranslate('errorTitleRejected');
                textElement = (
                    <div>
                        <div className="hire-card-neruda-error__text">
                            <FormattedText
                                value={getContextTranslate('errorTextCallUs2')}
                            />
                        </div>
                        <div className="hire-card-neruda-error__phone">
                            <i className="hire-card-neruda-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value={getContextTranslate('phoneNumberClients')} />
                        </div>
                    </div>
                );
                break;
            case LOW_CREDIT_SCORE:
                titleKey = getContextKeyTranslate('errorTitle');
                const documentationLink = (
                    <a onClick={() => this.handleGoToDocumentation()} >
                        <FormattedText value={getContextTranslate('documentation')} />
                    </a>
                    );
                textElement = (
                    <div>
                        <div className="hire-card-neruda-error__text hire-card-neruda-error__text--margin-bottom">
                            <FormattedText value={getContextKeyTranslate('errorTextElement1')} />
                            {documentationLink}
                            <FormattedText value={getContextKeyTranslate('errorTextElement2')} />
                        </div>
                    </div>
                );
                break;
        }

        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { textElement, titleKey } = this.buildTexts();
        const { getContextTranslate, hasAvailableAccounts, maxAllowedNumberCards, processDetail, hireRestrictionFlag } = this.props
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }: hasAvailableAccounts && !maxAllowedNumberCards ? {
            label: (
                <FormattedText
                    format="uppercase"
                    value={getContextTranslate('errorBackButtonText')}
                />
            ),
            url: '/myprofile/global'
        } :
        ({
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCards-backButtonLabel"
                />
            ),
            url: '/myprofile/cards'
        });
        const cancleButton ={
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionCancleButtonText"
                />
            ),
            url: '/myprofile/cards'
            };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.NERURA_CARD_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-card-neruda-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

HireCreditCardError.propTypes = {
    getContextTranslate: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    hireCreditCard: PropTypes.object.isRequired,
    hasAvailableAccounts: PropTypes.bool,
    maxAllowedNumberCards: PropTypes.bool,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool,
};

HireCreditCardError.defaultProps =
{
    hireRestrictionFlag : false
}

module.exports = withRouter(HireCreditCardError);
